import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { StatisticDataCard } from '@component/statistical-highlights/statistical-highlights.component';
import { applyValues } from '@helpers/objects';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-statistic-data-card',
  styleUrls: ['./statistic-data-card.component.scss'],
  templateUrl: './statistic-data-card.component.html'
})
export class StatisticDataCardComponent implements OnInit {
  @Input() card: StatisticDataCard;
  @Input() last: boolean;

  svg: string;
  statistic: string;
  description: string;

  constructor() {}

  ngOnInit(): void {
    let keys = ['svg', 'statistic', 'description'];
    applyValues({ data: this.card, keys, obj: this });
  }
}
